import { ReactNode } from "react";
import { RoutePath } from "@src/interfaces/RoutePath";
import { IntegrationConfig, IntegrationType } from "@src/interfaces";
import { BaseIntegration } from "../BaseIntegration";
import { Swap } from "./Swap";

/**
 * Swap Integration - handles basic buy/sell operations
 * This is the default integration that was previously the only option
 */
export class SwapIntegration extends BaseIntegration {
  readonly type = IntegrationType.Swap;

  render(tab: RoutePath): ReactNode {
    return <Swap tab={tab} />;
  }

  getConfig(): IntegrationConfig {
    return {
      type: this.type,
      name: "Swap",
      description: "Buy and sell cryptocurrencies with fiat",
    };
  }
}
